module.exports = __webpack_public_path__ + "media/images/home/tagline-bg-f0a5223d12fa64a74d1e6ed42c226826.jpg";